import { useState } from "react";

const services = [
  { icon: "ri-passport-line", title: "New Passport", desc: "First-time application assistance for UA students and NWA residents." },
  { icon: "ri-refresh-line", title: "Passport Renewal", desc: "Fast renewal for expired or soon-to-expire passports." },
  { icon: "ri-alert-line", title: "Lost/Stolen", desc: "Emergency replacement with DS-64 form guidance." },
  { icon: "ri-user-smile-line", title: "Child Passport", desc: "Minors under 16 with parental consent guidance." },
  { icon: "ri-time-line", title: "Emergency", desc: "24-hour processing for NWA corporate emergencies." },
  { icon: "ri-edit-line", title: "Name Change", desc: "Post-marriage or legal name change updates." },
];

export default function FayettevilleARServicesSection() {
  return (
    <section id="services" className="py-16 md:py-24 bg-[#F7F8FA]">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-12">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Our Services</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">Passport Services for Fayetteville, AR &amp; NWA Travelers</h2>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {services.map((s, i) => (
            <div key={i} className="bg-white border border-gray-200 rounded-lg p-6 hover:border-[#F6C344] transition-all">
              <div className="w-12 h-12 flex items-center justify-center rounded-full bg-[#EEF2F8] mb-4"><i className={`${s.icon} text-[#1A365D] text-xl`}></i></div>
              <h3 className="font-bold text-[#1A365D] text-lg mb-2">{s.title}</h3>
              <p className="text-gray-500 text-sm leading-relaxed">{s.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}